export default class JourneyPoint {
    constructor (
        address,
        location,
        utc,
    ) {
        this.address = address
        this.location = location
        this.utc = utc
    }
}
